import { render } from "./UserPreferencesSettings.vue?vue&type=template&id=289775ce"
import script from "./UserPreferencesSettings.vue?vue&type=script&lang=js"
export * from "./UserPreferencesSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__